export default __webpack_public_path__ + "static/media/c.53bd4418.mp4";